// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: otxlHe2K5B0H
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  hasVariant,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import { useScreenVariants as useScreenVariantseuyRl26Gw8Ft } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: EuyRl26Gw8Ft/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicInvoiceFields.module.css"; // plasmic-import: otxlHe2K5B0H/css

createPlasmicElementProxy;

export const PlasmicInvoiceFields__VariantProps = new Array("firstone");

export const PlasmicInvoiceFields__ArgProps = new Array();

const $$ = {};

function PlasmicInvoiceFields__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "firstone",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.firstone
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantseuyRl26Gw8Ft()
  });
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        sty.root
      )}
    >
      <input
        data-plasmic-name={"item"}
        data-plasmic-override={overrides.item}
        className={classNames(projectcss.all, projectcss.input, sty.item)}
        placeholder={hasVariant(globalVariants, "screen", "medium") ? "" : ""}
        ref={ref => {
          $refs["item"] = ref;
        }}
        size={1}
        type={"text"}
        value={""}
      />

      <input
        data-plasmic-name={"quantity"}
        data-plasmic-override={overrides.quantity}
        className={classNames(projectcss.all, projectcss.input, sty.quantity)}
        placeholder={""}
        ref={ref => {
          $refs["quantity"] = ref;
        }}
        size={1}
        type={"number"}
        value={""}
      />

      <div
        data-plasmic-name={"pricing"}
        data-plasmic-override={overrides.pricing}
        className={classNames(projectcss.all, sty.pricing)}
      />

      <div
        data-plasmic-name={"deleteField"}
        data-plasmic-override={overrides.deleteField}
        className={classNames(
          projectcss.all,
          projectcss.__wab_text,
          sty.deleteField,
          {
            [sty.deleteFieldfirstone]: hasVariant(
              $state,
              "firstone",
              "firstone"
            )
          }
        )}
      >
        {"X"}
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  root: ["root", "item", "quantity", "pricing", "deleteField"],
  item: ["item"],
  quantity: ["quantity"],
  pricing: ["pricing"],
  deleteField: ["deleteField"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicInvoiceFields__ArgProps,
          internalVariantPropNames: PlasmicInvoiceFields__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicInvoiceFields__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicInvoiceFields";
  } else {
    func.displayName = `PlasmicInvoiceFields.${nodeName}`;
  }
  return func;
}

export const PlasmicInvoiceFields = Object.assign(
  // Top-level PlasmicInvoiceFields renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    item: makeNodeComponent("item"),
    quantity: makeNodeComponent("quantity"),
    pricing: makeNodeComponent("pricing"),
    deleteField: makeNodeComponent("deleteField"),
    // Metadata about props expected for PlasmicInvoiceFields
    internalVariantProps: PlasmicInvoiceFields__VariantProps,
    internalArgProps: PlasmicInvoiceFields__ArgProps
  }
);

export default PlasmicInvoiceFields;
/* prettier-ignore-end */
